import { DrawerTypes } from '../reducers/drawer'
import { AppThunk } from '../misc';
import { Query, redirect } from 'redux-first-router';
import { RootState } from '../reducers/persistedReducer';
import { ROUTE_ACTIONS } from '../routes';

export type ClusterRouteOptions = {
  payload?: object,
  query?: Query,
  keepQuery?: string[]
}

// Asyncronous doRoute when a state is not already provided.
export const doRoute = (type: keyof typeof ROUTE_ACTIONS, options?: ClusterRouteOptions, doRedirect: boolean = false): AppThunk => (dispatch, getState) => {
  const state = getState();
  return dispatch(doRouteSync(state, type, options, doRedirect));
};

// Helper function to enforce correct route action types.
export const doRouteSync = (state: RootState, type: keyof typeof ROUTE_ACTIONS, options?: ClusterRouteOptions, doRedirect: boolean = false) => {
  // An array of query parameters to call back from the state.
  let keepQuery: string[];

  // If no keepquery option is specified, save the show query param.
  const defaultKeepQuery = ["show"];

  if (options?.keepQuery) {
    keepQuery = options.keepQuery;
  } else {
    keepQuery = defaultKeepQuery;
  }

  // Building our query starting with what we requested.
  let newQuery = options?.query??{};

  // Removes keepquery keys that are being overwritten by the request query.
  // Example: setting query:{show=channels} will override keepQuery:[show]
  const getQueryKeys = keepQuery.filter(x => !Object.keys(newQuery).includes(x));

  // If any query keys are needed, request them from state and put them in our new query object.
  if (getQueryKeys.length > 0) {
    const prevQuery = state.location.query;

    if (prevQuery) {
      getQueryKeys.forEach(key => {
        if(prevQuery[key]) {
          newQuery[key] = prevQuery[key];
        }
      })
    }
  }

  const route = {type, payload: options?.payload, query: newQuery};
  return (doRedirect ? redirect(route) : route);
}

export const doSwitchDrawer = (drawer: DrawerTypes): AppThunk => (dispatch, getState) => {
  const state = getState();
  let { type, payload, query } = state.location;

  if (typeof query === "undefined") {
    query = {};
  }

  query.show = drawer;

  return dispatch(doRouteSync(state, type as ROUTE_ACTIONS, {payload, query}, true));
}
